import Vue from 'vue';
const get = (url, params) => {
  const path = process.env.VUE_APP_BASE_PATH + url;
  return new Promise((resolve, reject) => {
    Vue.axios.get(path, {params: params}).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.response);
    })
  });
};
const post = (url, params) => {
  const path = process.env.VUE_APP_BASE_PATH + url;
  return new Promise((resolve, reject) => {
    Vue.axios.post(path, params).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.response);
    })
  });
}
export default {
  // 提交表单
  submitForm(params) {
    return post('/api/form/create', params);
  },
  // 获取表单填写信息
  getResult(params) {
    return get('/api/form/inquire', params);
  },
  // 获取表单填写信息
  exportResult(params) {
    return get('/api/form/export', params);
  },
  // 登录
  login(params) {
    return post('/api/admin/login', params)
  },
  // 提交表单到线索管理
  submitToClue(params) {
    return post('/api/thirdParty/clue', params);
  },
  // 获取页面路由配置
  getRoutes(params) {
    return get('/api/pages/routes', params);
  },

  getReport(params) {
    return get('/api/staff/meeting/report', params);
  }
}